
//---------*****代理商级别********-------------//
export const SUPER_MANAGER = 10;

export const COMMON_MANAGER = 20; // 普通管理员

export const EMPLOYEE = 30; // 员工
